<div class="modal-header">
  <h3 class="modal-title">
    {{ options?.title }}
  </h3>
  <button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="cancel()"
  >
  </button>
</div>

<div
  class="modal-body"
  (scroll)="onScroll($event)"
>
  @if (isIgnite || isClubHub) {
    <lib-disclaimer-content-ignite />
  }
  @if (isLenderHub) {
    <lib-disclaimer-content-lenderhub />
  }
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-colour-grayscale-700"
    (click)="cancel()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-colour-blue-600"
    [disabled]="isDisabled"
    (click)="yes()"
  >
    Accept
  </button>
</div>
